import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42cb866b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents-inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " WorkflowSystem ", -1))
const _hoisted_3 = { class: "login" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note" }, [
  /*#__PURE__*/_createElementVNode("p", null, "現在、ログインはSlack連携によるログインのみです。"),
  /*#__PURE__*/_createElementVNode("p", null, "Slack連携によるログインをお願いします。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginLogo = _resolveComponent("LoginLogo")!
  const _component_SlackLoginButton = _resolveComponent("SlackLoginButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_LoginLogo),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SlackLoginButton)
      ]),
      _hoisted_4
    ])
  ]))
}